import { createFileRoute } from "@tanstack/react-router";
import { NotificationsPage } from "@/components/dashboard/notifications-page";
export const Route = createFileRoute("/notifications")({
 head:()=>({meta:[{title:"Notifications — Deuxda Admin"},{name:"description",content:"Build, schedule and measure push campaigns."},{property:"og:title",content:"Notifications — Deuxda Admin"},{property:"og:description",content:"Build, schedule and measure push campaigns."},{property:"og:type",content:"website"},{name:"twitter:card",content:"summary_large_image"}]}),
 component: NotificationsPage,
});
